import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { messengerActionUpdate, messengerQuotingComplete, messengerQuotingInProgress, messengerQuotingMessage, } from './messenger.actions';
import { filter, map, tap } from 'rxjs/operators';
import { quotingUpdate } from '../quote-progress/quote-progress.actions';
import { ActionService } from '../../modules/shared/services/action.service';
import { ShipmentService } from '../../data/shipment.service';
import { MergeStrategy } from '@ngrx/data';

@Injectable()
export class MessengerEffects {
    constructor(private actions$: Actions, private actionService: ActionService, private shipmentService: ShipmentService) {
    }

    actionUpdate$ = createEffect(() => this.actions$.pipe(
        ofType(messengerActionUpdate),
        map((action) => this.actionService.updateReceived(action.action))
    ), { dispatch: false });

    quotingUpdateQuotes$ = createEffect(() => this.actions$.pipe(
        ofType(messengerQuotingInProgress),
        filter((action) => !!action.quotes),
        map((action) => quotingUpdate({ id: action.id, messages: action.messages || null, progress: action.progress, quotes: action.quotes }))
    ));

    quotingUpdateMessages$ = createEffect(() => this.actions$.pipe(
        ofType(messengerQuotingMessage),
        filter((action) => !!action.messages),
        map((action) => quotingUpdate({ id: action.id, messages: action.messages, progress: null, quotes: [] }))
    ));

    quotingCompleted$ = createEffect(() => this.actions$.pipe(
        ofType(messengerQuotingComplete),
        tap((action) => this.shipmentService.cacheQuotes(action.id, action.quotes, action.preSelectedId))
    ), { dispatch: false });

}
